import ServiceBase from './ServiceBase';

export default class EmployeeUserService extends ServiceBase {
    async getUsers() {
        var results = await this.requestJson({
            url: `api/admin/employeeuser`,
            method: "GET"
        });

        return results;
    }

    async getUser(id) {
        var result = await this.requestJson({
            url: `api/admin/employeeuser/${id}`,
            method: "GET"
        });

        return result;
    }

    async updateUser(user) {
        var result = await this.requestJson({
            url: `api/admin/employeeuser/${user.id}`,
            method: "PUT",
            data: user
        });

        return result;
    }

    async createUser(user) {
        var result = await this.requestJson({
            url: `api/admin/employeeuser/`,
            method: "POST",
            data: user
        });

        return result;
    }

    async addUserToRole(userId, roleId) {
        var result = await this.requestJson({
            url: `api/admin/employeeuser/role`,
            method: "POST",
            data: { "userId": userId, "roleId": roleId, "tenantId": 1 }
        });

        return result;
    }
}